import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

import "./common.css";

const LandingHeader = () => {
  const location = useLocation();
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 0);
    };
    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const isHome = location.pathname === "/" || location.pathname === "/home";
  const isAbout = location.pathname === "/about";
  const isContact = location.pathname === "/contact";
  const isPricing = location.pathname === "/pricing";
  const isFeatures = location.pathname === "/features";

  return (
    <nav className={`navbar navbar-expand-lg${scrolled ? " activeScroll" : ""}`}>
      <div className="container">
        <a className="navbar-brand" href="#">
          <img src="./assets/images/JigyaasuBlackLogo.svg" alt="" />
        </a>
        <button
          className="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarSupportedContent"
          aria-controls="navbarSupportedContent"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </button>
        <div className="collapse navbar-collapse" id="navbarSupportedContent">
          <ul className="ff1 navbar-nav mx-auto mb-2 mb-lg-0">
            <li className="nav-item">
              <a className={`nav-link ${isHome ? " active" : ""}`} href="/home" aria-current={isHome ? "page" : undefined}>
                Home
              </a>
            </li>
            <li className="nav-item">
              <a className={`nav-link ${isAbout ? " active" : ""}`} href="/about" aria-current={isAbout ? "page" : undefined}>
                About Us
              </a>
            </li>
            <li className="nav-item dropdown">
              <a
                className="nav-link dropdown-toggle"
                href="#"
                role="button"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                Features
                <img src="./assets/images/landing/icon-dd-line-arrow.svg" alt="" />
              </a>
              <ul className="mt-lg-3 dropdown-menu">
                <li>
                  <a className={`dropdown-item ${isFeatures ? " active" : ""}`} href="/features" aria-current={isFeatures ? "page" : undefined}  >
                    Feature1
                  </a>
                </li>
                <li>
                  <a className="dropdown-item" href="#">
                    Feature2
                  </a>
                </li>
                <li>
                  <a className="dropdown-item" href="#">
                    Feature3
                  </a>
                </li>
              </ul>
            </li>
            {/* <li className="nav-item dropdown">
              <a
                className="nav-link dropdown-toggle"
                href="#"
                role="button"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                Company
                <img src="./assets/images/landing/icon-dd-line-arrow.svg" alt="" />
              </a>
              <ul className="mt-lg-3 dropdown-menu">
                <li>
                  <a className="dropdown-item" href="#">
                    Company1
                  </a>
                </li>
                <li>
                  <a className="dropdown-item" href="#">
                    Company2
                  </a>
                </li>
                <li>
                  <a className="dropdown-item" href="#">
                    Company3
                  </a>
                </li>
              </ul>
            </li> */}
            <li className="nav-item">
              <a className={`nav-link ${isPricing ? " active" : ""}`} href="/pricing" aria-current={isPricing ? "page" : undefined}>
                Pricing
              </a>
            </li>
            <li className="nav-item">
              <a className={`nav-link ${isContact ? " active" : ""}`} href="/contact" aria-current={isContact ? "page" : undefined}>
                Contact Us
              </a>
            </li>
            {/* <li className="nav-item">
              <a className="nav-link disabled" aria-disabled="true">Disabled</a>
            </li> */}
          </ul>

          <div className="authentication-buttons">
            <div className="dropdown">
              <a
                className="dropdown-toggle"
                href="#"
                role="button"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                EN
                <img src="./assets/images/landing/icon-dd-line-arrow.svg" alt="" />
              </a>
              <ul className="mt-lg-3 dropdown-menu">
                <li>
                  <a className="dropdown-item" href="#">
                    English
                  </a>
                </li>
                <li>
                  <a className="dropdown-item" href="#">
                    French
                  </a>
                </li>
                <li>
                  <a className="dropdown-item" href="#">
                    Hindi
                  </a>
                </li>
              </ul>
            </div>
            <button className="btn btn-solid  btn-solid--dark" type="button">
              Login
            </button>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default LandingHeader;